import { LoanInfo } from '@/containers/LoanInfo';

const LoanInfoModal = ({ selectedLoan, ...props }) => (
  <LoanInfo info={selectedLoan} {...props} />
);

export default LoanInfoModal;
